/* Bounded display previews only. Never request or link private production files. */
(function () {
  'use strict';
  function previewUrl(source, base) {
    try {
      var url = new URL(source, base);
      var origin = new URL(base).origin;
      if (!/^https?:$/.test(url.protocol)) return null;
      if (url.origin !== origin && url.hostname !== 'cdn.shopify.com') return null;
      url.searchParams.set('width', '1600');
      url.searchParams.set('height', '1600');
      return url.href;
    } catch (_) { return null; }
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = { previewUrl: previewUrl };
  if (typeof document === 'undefined') return;
  function init() {
    var dialog = document.querySelector('[data-ev-image-viewer]');
    if (!dialog || dialog.getAttribute('data-ready')) return;
    dialog.setAttribute('data-ready', 'true');
    var large = dialog.querySelector('[data-ev-image-large]');
    var caption = dialog.querySelector('[data-ev-image-caption]');
    var status = dialog.querySelector('[data-ev-image-status]');
    var opener = null, previousOverflow = '';
    var note = 'Display preview only — not the production print file.';
    document.querySelectorAll('[data-ev-enlarge]').forEach(function (link) {
      var image = link.querySelector('img');
      if (!image) return;
      var lastSource = image.getAttribute('src');
      function sync() {
        var currentSource = image.getAttribute('src');
        if (currentSource !== lastSource) {
          var next = previewUrl(currentSource, location.href);
          if (next) link.href = next;
          lastSource = currentSource;
        }
      }
      if (window.MutationObserver) {
        new MutationObserver(sync).observe(image, { attributes: true, attributeFilter: ['src'] });
      }
      link.addEventListener('click', function (event) {
        sync();
        // Preserve the ordinary bounded-image link if native dialogs are unavailable.
        if (typeof dialog.showModal !== 'function' || event.metaKey || event.ctrlKey ||
            event.shiftKey || event.altKey || event.button > 0) return;
        var url = previewUrl(link.href, location.href);
        if (!url) return;
        event.preventDefault();
        if (dialog.open) return;
        opener = link;
        previousOverflow = document.documentElement.style.overflow;
        status.textContent = note;
        caption.textContent = image.alt || 'Artwork preview';
        large.alt = image.alt || 'Artwork preview';
        large.hidden = false;
        large.src = url;
        document.documentElement.style.overflow = 'hidden';
        dialog.showModal();
      });
    });
    large.addEventListener('error', function () {
      status.textContent = 'The preview could not load. Close it and try again.';
    });
    dialog.querySelector('[data-ev-image-close]').addEventListener('click', function () { dialog.close(); });
    dialog.addEventListener('click', function (event) { if (event.target === dialog) dialog.close(); });
    // Escape and keyboard focus containment are handled by the native dialog.
    dialog.addEventListener('close', function () {
      document.documentElement.style.overflow = previousOverflow;
      large.hidden = true;
      large.removeAttribute('src');
      if (opener && opener.isConnected) opener.focus();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
